export default __webpack_public_path__ + "static/media/desktop_89.aaa8b22f.jpg";